import * as z from "zod/v4";

export const updateNewOrderItems = {
  name: "updateNewOrderItems" as const,
  input: z.object({
    teamId: z.string(),
    returnId: z.string(),
    items: z.array(
      z.object({
        quantity: z.number(),
        variantId: z.string(),
        productId: z.string().optional(),
      }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
